webpackJsonp([83],{

/***/ 1184:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var customMethods = {
	list: { method: 'GET', url: 'housemaid-list' },
	housekeepingRooms: { method: 'GET', url: 'housekeeping-rooms' }
};

function housemaid(vm) {
	return vm.$resource('housemaid{/id}', {}, customMethods);
}

/* harmony default export */ __webpack_exports__["a"] = (housemaid);

/***/ }),

/***/ 1346:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_table_run__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_table_run___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_table_run__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared_mixins__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__resource_housemaid__ = __webpack_require__(1184);




var loadData = function () {
	var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
		var parameters, filterGroups, response;
		return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
			while (1) {
				switch (_context.prev = _context.next) {
					case 0:
						parameters = {
							page: this.page,
							limit: this.limit
						};
						filterGroups = [];

						if (this.stateId) {
							filterGroups.push(this.renderFilter('hk_ms_statehk_housemaid_id', this.stateId, 'eq'));
							parameters.filter_groups = filterGroups;
						}
						if (this.sortFilter) {
							parameters.sort = this.sortFilter;
						}
						if (this.search) {
							filterGroups.push(this.search);
							parameters.filter_groups = filterGroups;
						}
						_context.next = 7;
						return this.resource.list(parameters);

					case 7:
						response = _context.sent;

						this.totalPages = response.data.last_page;
						this.rows = response.data.data;

					case 10:
					case 'end':
						return _context.stop();
				}
			}
		}, _callee, this);
	}));

	return function loadData() {
		return _ref2.apply(this, arguments);
	};
}();

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





function created() {
	this.resource = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__resource_housemaid__["a" /* default */])(this);
	this.loadData();
}

function callServiceAndExport(rows) {
	var fieldNames = this.columns.map(function (column) {
		return column.name;
	});
	var columns = this.columns.map(function (column) {
		return column.code;
	});
	this.exportToCSV(fieldNames, columns, rows, 'Estado ' + this.stateName + ': Listado de mucamas.');
}

function callServiceAndSearch(search) {
	this.search = this.renderFilter('name', search, 'ct');
	this.page = 1;
	this.loadData();
}

function columnSortableEvent(_ref) {
	var id = _ref.id;

	var self = this;
	var newColumn = self.columns.filter(function (column) {
		return column.id === id;
	});
	newColumn[0].isSortable = newColumn[0].isSortable.down ? { down: false, up: true } : { down: true, up: false };
	self.columns = self.columns.map(function (columnSingle) {
		var newColumnSingle = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, columnSingle);
		if (columnSingle.id !== newColumn[0].id && columnSingle.isSortable) {
			newColumnSingle.isSortable = { down: true, up: false };
		}
		return newColumnSingle;
	});
	var sortGroup = [];
	sortGroup.push(this.renderSort(newColumn[0].code, newColumn[0].isSortable.up ? 'ASC' : 'DSC'));
	this.sortFilter = sortGroup;
	this.loadData();
}

/* harmony default export */ __webpack_exports__["default"] = ({
	components: {
		TableRun: __WEBPACK_IMPORTED_MODULE_3_table_run___default.a
	},
	created: created,
	data: function data() {
		return {
			columns: [{ id: 1, name: 'Mucamas', code: 'name', isSortable: { down: true, up: false } }, { id: 2, name: 'Supervisor', code: 'supervisor_name', isSortable: { down: true, up: false } }, { id: 3, name: 'Estado', code: 'state' }],
			limit: 10,
			page: 1,
			resource: null,
			rows: [],
			search: null,
			sortFilter: null,
			totalPages: 5
		};
	},

	methods: {
		callServiceAndExport: callServiceAndExport,
		callServiceAndSearch: callServiceAndSearch,
		columnSortableEvent: columnSortableEvent,
		loadData: loadData
	},
	mixins: __WEBPACK_IMPORTED_MODULE_4__shared_mixins__["a" /* default */],
	name: 'housemaids-by-state',
	props: ['stateId', 'stateName']
});

/***/ }),

/***/ 1640:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "md12": "",
      "text-xs-left": ""
    }
  }, [_c('h2', {
    staticClass: "headline"
  }, [_vm._v("Estado: " + _vm._s(_vm.stateName))])])], 1), _vm._v(" "), _c('table-run', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "include-delete": false,
      "include-search": true,
      "include-export-to-excel": true,
      "include-options": true,
      "include-state": true
    },
    on: {
      "on-sortable-event": _vm.columnSortableEvent,
      "on-export-selected": _vm.callServiceAndExport,
      "on-search-event": _vm.callServiceAndSearch
    },
    scopedSlots: _vm._u([{
      key: "rows",
      fn: function(props) {
        return [_c('td', [_vm._v(_vm._s(props.row.name) + " " + _vm._s(props.row.lastname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.row.supervisor_name) + " " + _vm._s(props.row.supervisor_lastname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.stateName))])]
      }
    }])
  }), _vm._v(" "), (_vm.rows.length === 0) ? _c('div', {
    staticClass: "mt-2"
  }, [_vm._v("No se encontró data en este estado.")]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 852:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(2)(
  /* script */
  __webpack_require__(1346),
  /* template */
  __webpack_require__(1640),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ })

});


// WEBPACK FOOTER //
// static/js/83.7f436758e5c75fc907fc.js